export default __webpack_public_path__ + "static/b-card-action-labels-f10de9cc16d4df4b020fb352bc9a6e1c.jpg";